{
  "Accessibility Menu": "Izbornik Pristupačnosti",
  "Reset settings": "Resetiraj postavke",
  "Close": "Zatvori",
  "Content Adjustments": "Prilagodbe Sadržaja",
  "Adjust Font Size": "Prilagodi Veličinu Fonta",
  "Highlight Title": "Istakni Naslove",
  "Highlight Links": "Istakni Poveznice",
  "Readable Font": "Čitljiv Font",
  "Color Adjustments": "Prilagodbe Boja",
  "Dark Contrast": "Tamni Kontrast",
  "Light Contrast": "Svijetli Kontrast",
  "High Contrast": "Visoki Kontrast",
  "High Saturation": "Visoka Zasićenost",
  "Low Saturation": "Niska Zasićenost",
  "Monochrome": "Jednobojno",
  "Contrast": "Kontrast",
  "Invert Colors": "Invertiraj boje",
  "Tools": "Alati",
  "Reading Guide": "Vodič Za Čitanje",
  "Stop Animations": "Zaustavi Animacije",
  "Big Cursor": "Veliki Kursor",
  "Increase Font Size": "Povećaj Veličinu Fonta",
  "Decrease Font Size": "Smanji Veličinu Fonta",
  "Letter Spacing": "Razmak Između Slova",
  "Line Height": "Visina Linije",
  "Font Weight": "Debljina Fonta",
  "Dyslexia Font": "Font Za Disleksiju",
  "Language": "Jezik",
  "Open Accessibility Menu": "Otvori Izbornik Pristupačnosti",
  "Widget Settings": "Postavke widgeta",
  "Widget Position": "Pozicija widgeta",
  "Top Left": "Gore lijevo",
  "Top Center": "Gore u sredini",
  "Top Right": "Gore desno",
  "Center Left": "Sredina lijevo",
  "Center Right": "Sredina desno",
  "Bottom Left": "Dolje lijevo",
  "Bottom Center": "Dolje u sredini",
  "Bottom Right": "Dolje desno",
  "Screen Reader": "Čitač zaslona",
  "Voice Navigation": "Glasovna navigacija",
  "Custom Color": "Prilagođena boja",
  "Change the site's colors": "Promijeni boje stranice",
  "Backgrounds": "Pozadine",
  "Headings": "Naslovi",
  "Contents": "Sadržaji",
  "Reset colors": "Resetiraj boje",
  "Image Desaturation": "Desaturacija slike",
  "Search languages": "Pretraži jezike",
  "No languages found": "Nema pronađenih jezika",
  "Accessibility Profiles": "Profili pristupačnosti",
  "Motor Impaired": "Motoričko oštećenje",
  "Big cursor, voice navigation, and no animations.": "Veliki kursor, glasovna navigacija i bez animacija.",
  "Blind": "Slijepi",
  "Screen reader helpers with higher contrast.": "Pomagala čitača ekrana s većim kontrastom.",
  "Color Blind": "Slabovidnost boja",
  "High contrast palette with desaturated media.": "Paleta visokog kontrasta s manje zasićenim medijima.",
  "Dyslexia": "Disleksija",
  "Friendly font, extra spacing, stronger weight.": "Prilagođen font, veći razmak i jače podebljanje.",
  "Low vision": "Slab vid",
  "Dark contrast and 130% magnification.": "Taman kontrast i povećanje 130 %.",
  "Cognitive & Learning": "Kognitivno i učenje",
  "Highlights key sections and enables voice help.": "Ističe ključne sekcije i uključuje glasovnu pomoć.",
  "Seizure & Epileptic": "Napadaji i epilepsija",
  "Stops animations and desaturates imagery.": "Zaustavlja animacije i smanjuje zasićenost slika.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Vodič za čitanje, istaknute poveznice i smirenija paleta.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
